import { Component, Input, OnInit } from '@angular/core';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { UserService } from '@shared/services/user.service';
import moment from 'moment';
import { ANESTHETIST, IADE } from 'src/app/shared/const/globals.const';
import { Profile } from '../../models/profile.model';

@Component({
  selector: 'app-popup-switch-request-infos',
  templateUrl: './popup-switch-request-infos.component.html',
  styleUrls: ['./popup-switch-request-infos.component.scss'],
  standalone: false,
})
export class PopupSwitchRequestInfosComponent implements OnInit {
  @Input() public cr: any;

  public profile1: Profile | undefined;

  public profile2: Profile | undefined;

  public date1: string = '';

  public date2: string = '';

  public period1: string = '';

  public period2: string | undefined = '';

  public type: string = 'Astreinte';

  public hospitalNames: HospitalNames;

  constructor(private userService: UserService) {
    this.hospitalNames = this.userService.getHospitalNames();
  }

  ngOnInit() {
    this.profile1 = this.cr.calendar1.profile;
    this.profile2 = this.cr.calendar2.profile;

    this.date1 = moment(this.cr.calendar1.date).format('DD/MM/YYYY');
    this.date2 = moment(this.cr.calendar2.date).format('DD/MM/YYYY');

    let start = new Date(this.cr.calendar1.morningStartTime);
    let end = new Date(this.cr.calendar1.afternoonEndTime);

    if (this.cr.type == 'garde') {
      this.period2 = undefined;
    } else if (end.getHours() <= 13) {
      this.period1 = 'Matin';
    } else if (start.getHours() >= 13) {
      this.period1 = 'Après-midi';
    } else {
      this.period1 = 'Journée';
    }

    start = new Date(this.cr.calendar2.morningStartTime);
    end = new Date(this.cr.calendar2.afternoonEndTime);

    if (this.cr.type == 'garde') {
      this.period2 = undefined;
    } else if (end.getHours() <= 13) {
      this.period2 = 'Matin';
    } else if (start.getHours() >= 13) {
      this.period2 = 'Après-midi';
    } else {
      this.period2 = 'Journée';
    }
    if (this.profile1?.position == ANESTHETIST) {
      this.type = this.cr.type == 'garde' ? 'Garde' : this.hospitalNames.extracliniqueName;
    }
    if (IADE.includes(this.profile1?.position ?? '')) {
      this.type = 'Garde IADE';
    }
  }
}
